import React, { useCallback, useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import Swal from "sweetalert2";
import FullScreenLoader from '../Components/FullScreenLoader'

const UsersManagment = () => {
  const [loading, setLoading] = useState(false)
    const [allUsers, setAllUsers] = useState(null)
    const BASE_URl = window.location.origin
    
  const getAllUser = useCallback(()=>{
    fetch(`${BASE_URl}/api/allUser`, {
      method: 'GET',
      credentials: 'include'
    }).then((res) => res.json())
    .then((data) => setAllUsers(data.allUsers))
    .catch((error) =>{
      console.log(error)
    })
  },[BASE_URl])

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });
  
    if (result.isConfirmed) {
      setLoading(true)
      fetch(`${BASE_URl}/api/admin/deleteUser/${id}`, {
        method: 'GET',
        credentials: 'include'
      }).then((res) => res.json())
      .then((data) => {
        if(data&&data.sucess === true){
          setLoading(false)
          toast.success(data.messege)
          getAllUser()
        } else if(data&&data.sucess === false){
          setLoading(false)
          toast.error(data.messege)
        }
      })
      .catch((error) => {
        setLoading(false)
        toast.error(error.messege|| 'Internal Server Error')})// ✅ True if user clicked "Yes"
    } else {
      setLoading(false)
      toast.success('User Not Deleted')
    }
  };

  useEffect(()=>{
    getAllUser()
  }, [getAllUser])

  const UserCard = ({ user }) => {
    return (
      <div className="bg-white shadow-md p-4 rounded-lg flex flex-col items-center gap-3 border border-gray-200 w-full sm:w-[280px]">
        <img
          src={user.profilePic.secure_url}
          alt={user.name}
          className="w-20 h-20 object-cover rounded-full border-2 border-blue-500"
        />
        <h2 className="text-lg font-semibold">{user.name}</h2>
        <p className="text-gray-500 text-sm">{user.email}</p>
        
        {/* Display User Role (Admin/User) */}
        <span
          className={`px-3 py-1 text-sm font-medium rounded-full ${
            user.role === "Admin" ? "bg-yellow-100 text-yellow-600" : "bg-blue-100 text-blue-600"
          }`}
        >
          {user.role === "Admin" ? "👑 Admin" : "👤 User"}
        </span>
  
        {/* Verified Status */}
        <span
          className={`px-3 py-1 text-sm font-medium rounded-full ${
            user.isVerifed ? "bg-green-100 text-green-600" : "bg-red-100 text-red-600"
          }`}
        >
          {user.isVerifed ? "✔ Verified" : "❌ Not Verified"}
        </span>
  
        <button
          onClick={() => handleDelete(user._id)}
          className="mt-3 px-4 py-2 text-white bg-red-500 hover:bg-red-600 rounded-lg transition cursor-pointer"
        >
          Delete
        </button>
      </div>
    );
  };
  


  return (
    <div className='mt-14 mb-10'>
     <div className="p-5">
      <h1 className="text-center text-2xl font-bold mb-6">User Profiles</h1>
      {loading?<FullScreenLoader/>:null}
      <div className="flex flex-wrap justify-center gap-6">
        {allUsers ? (
          <>
            {allUsers.map((user, i) => (
              <div key={i}>
              <UserCard key={user.id} user={user} />
              </div>
            ))}
          </>
        ) : null}
      </div>
    </div>
    </div>
  )
}

export default UsersManagment
